// import { Injectable } from '@angular/core';
// import { Actions, createEffect, ofType } from '@ngrx/effects';
// import { loadList, loadListSuccess, loadListFailure, loadObjectSuccess } from '../lib/action';
// import { catchError, concatMap, map } from 'rxjs/operators';
// import { Observable, of } from 'rxjs';
// import { MasterdataService, AdministrationService } from '../service';
// import { CommonService } from '../service/common/common.service';

// @Injectable()
// export class ListEffects {
//   constructor(
//     private actions$: Actions,
//     private masterdataService: MasterdataService,
//     private adminService: AdministrationService,
//     private commonService:CommonService
//   ) {}

//   loadList$ = createEffect(() =>

//     this.actions$.pipe(
//       ofType(loadList),
//       concatMap(({ listType }) => {
//         switch (listType) {
//           case 'profile':
//             return this.commonService.getProfileDetails().pipe(
//               map(res => {
//                 localStorage.setItem('userDetails', JSON.stringify(res));
//                 return loadObjectSuccess({ listType, data: res });
//               }),
//               catchError(error => {
//                 return of(loadListFailure({ listType, error }));
//               })
//             );
//           default:
//             return of(loadListFailure({ listType, error: 'Unknown list type' }));
//         }
//       })
//     )
//   );
// }
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadList, loadListSuccess, loadListFailure, loadObjectSuccess
} from '../lib/action';
import { catchError, concatMap, map,mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MasterdataService, AdministrationService } from '../service';
import { CommonService } from '../service/common/common.service';

@Injectable()
export class ListEffects {
  constructor(
    private actions$: Actions,
    private masterdataService: MasterdataService,
    private adminService: AdministrationService,
    private commonService: CommonService
  ) {}

  loadList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadList),
      mergeMap(({ listType }) => {
        switch (listType) {
          case 'profile':
            return this.commonService.getProfileDetails().pipe(
              map(res => {
                localStorage.setItem('userDetails', JSON.stringify(res));
                return loadObjectSuccess({ listType, data: res });
              }),
              catchError(error => of(loadListFailure({ listType, error })))
            );

          case 'country':
            return this.masterdataService.getCountryList({page:1,page_size:500}).pipe(
              map(res => loadListSuccess({ listType, items: res })),
              catchError(error => of(loadListFailure({ listType, error })))
            );

          case 'currency':
            return this.masterdataService.getCurrency({page:1,page_size:500}).pipe(
              map(res => loadListSuccess({ listType, items: res })),
              catchError(error => of(loadListFailure({ listType, error })))
            );

          case 'legal_entity':
            return this.masterdataService.getLegalEntityList({page:1,page_size:500}).pipe(
              map(res => loadListSuccess({ listType, items: res })),
              catchError(error => of(loadListFailure({ listType, error })))
            );

          case 'organisation':
              return this.masterdataService.getOrganisationList({page:1,page_size:500}).pipe(
                map(res => loadListSuccess({ listType, items: res })),
                catchError(error => of(loadListFailure({ listType, error })))
          );  

          case 'sertica-le':
              return this.masterdataService.getSerticaLe({page:1,page_size:500}).pipe(
                map(res => loadListSuccess({ listType, items: res })),
                catchError(error => of(loadListFailure({ listType, error })))
          );  

          default:
            return of(loadListFailure({ listType, error: 'Unknown list type' }));
        }
      })
    )
  );
}
